import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function updatePublication(purchaseId, action) {
    if (![ 'publish', 'unpublish' ].includes(action)) throw new Error('Invalid purchase action.');
    const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/purchases/${encodeURIComponent(purchaseId)}/${action}`,
        {},
        { headers: { Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}` } }
    );
    if (String(response.data?.status?.code) !== '10200' || !response.data?.data?._id) {
        const error = new Error(response.data?.status?.message || 'Unable to update purchase.');
        error.response = response;
        throw error;
    }
    return response.data.data;
}
